import { Backdrop, Box, Typography, CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';

interface Props {
  open: boolean;
}

const LoadingEmitirBoletoOverlay = ({ open }: Props) => {
  const [demora, setDemora] = useState(false);

  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (open) {
      setDemora(false);

      timer = setTimeout(() => {
        setDemora(true);
      }, 10000);
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [open]);

  return (
    <Backdrop
      open={open}
      sx={{
        zIndex: theme => theme.zIndex.modal + 1,
      }}
    >
      <Box
        sx={{
          backgroundColor: '#fff',
          borderRadius: 2,
          padding: 4,
          minWidth: 300,
          maxWidth: 420,
          textAlign: 'center',
          boxShadow: 3,
        }}
      >
        <CircularProgress
          color={demora ? 'warning' : 'primary'}
          sx={{ mb: 2 }}
        />

        <Typography
          variant="h6"
          fontWeight={600}
          color="text.primary"
          gutterBottom
        >
          {demora
            ? 'Estamos finalizando, só mais um pouco…'
            : 'Estamos gerando seu boleto'}
        </Typography>

        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ textAlign: 'left' }}
        >
          {demora ? (
            <>
              Esse processo pode levar até alguns minutos em alguns casos. 
              <strong> Fique tranquilo, sua solicitação continua em andamento.</strong>
            </>
          ) : (
            'Aguarde alguns instantes. Não feche esta página.'
          )}
        </Typography>

      </Box>
    </Backdrop>
  );

};

export default LoadingEmitirBoletoOverlay;
